import {createFormError, hideFormInfo, showFormInfo} from "../util/form";


export class FormGroup {

    get value() {
        return this.$input.value;
    }

    get name() {
        return this.$input.name;
    }

    /**
     *
     * @param {HTMLElement} el
     */
    constructor(el) {
        /**
         * @type {HTMLElement}
         */
        this.$el = el;

        /**
         * @type {HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement}
         */
        this.$input = el.querySelector("input, textarea, select");

        /**
         * @type {HTMLElement|null}
         */
        this.$error = null;

        this.$input.addEventListener("input", this.onInput.bind(this));
    }

    /**
     * @param {InputEvent} e
     */
    onInput(e) {
        this.hideError();
    }

    showError(message) {
        console.log("showError", message);
        this.$el.classList.add("form-group--invalid");

        if (!this.$error) {
            this.$error = createFormError(message);

            this.$input.after(this.$error);
        }

        showFormInfo(this.$error, message);
    }

    hideError() {
        console.log("hideError");
        this.$el.classList.remove("form-group--invalid");
        if (!this.$error) return;
        hideFormInfo(this.$error);
    }
}
